import { render } from "./InfoLayout1.vue?vue&type=template&id=385ea988&scoped=true"
const script = {}

import "./InfoLayout1.vue?vue&type=style&index=0&id=385ea988&lang=css"
import "./InfoLayout1.vue?vue&type=style&index=1&id=385ea988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385ea988"]])

export default __exports__